
export const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export const periodTimes = [
  "9:00 AM - 9:50 AM",
  "9:50 AM - 10:40 AM",
  "10:40 AM - 11:30 AM",
  "11:30 AM - 12:20 PM",
  "12:40 PM - 1:30 PM",
  "1:30 PM - 2:20 PM",
  "2:20 PM - 3:10 PM",
  "3:10 PM - 4:00 PM",
];

export const periods = 8;
